import { useState } from 'react';
import logo from '../assets/logo.png';
import './Donate.css';

const presets = ['₹101', '₹251', '₹501', '₹1,001', '₹2,501', '₹5,001'];

const causes = [
  { id: 'ganesh', icon: null, title: 'Ganesh Utsav Fund', desc: 'Support decorations, events and cultural programmes during Ganesh Chaturthi.' },
  { id: 'medical', icon: '🏥', title: 'Medical & Health Camps', desc: 'Fund free medical check-ups, blood donation drives and health awareness campaigns.' },
  { id: 'welfare', icon: '🍱', title: 'Community Welfare', desc: 'Help with free food distribution, scholarships and support for underprivileged families.' },
  { id: 'environment', icon: '🌳', title: 'Environmental Activities', desc: 'Support tree plantation, beach clean-up and environment protection initiatives.' },
];

const recentDonors = [
  { name: 'Ramesh P.', amount: '₹5,001', cause: 'Ganesh Utsav Fund', time: '2 hours ago' },
  { name: 'Sonal M.', amount: '₹1,001', cause: 'Medical Camp', time: '5 hours ago' },
  { name: 'Anon', amount: '₹501', cause: 'Community Welfare', time: '1 day ago' },
  { name: 'Jayesh D.', amount: '₹2,501', cause: 'Ganesh Utsav Fund', time: '2 days ago' },
];

export default function Donate() {
  const [selectedAmount, setSelectedAmount] = useState('₹501');
  const [customAmount, setCustomAmount] = useState('');
  const [selectedCause, setSelectedCause] = useState('ganesh');
  const [donorName, setDonorName] = useState('');
  const [donorEmail, setDonorEmail] = useState('');
  const [donorPhone, setDonorPhone] = useState('');
  const [anonymous, setAnonymous] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div className="donate-page">
        <div className="page-hero">
          <div className="container">
            <div className="badge">Donation</div>
            <h1>Make a Donation</h1>
          </div>
        </div>
        <section>
          <div className="container" style={{ maxWidth: 600, textAlign: 'center' }}>
            <div className="success-card card">
              <div style={{ fontSize: '4rem' }}>🙏</div>
              <h2>Thank You for Your Donation!</h2>
              <p>Your contribution of <strong>{customAmount || selectedAmount}</strong> towards <strong>{causes.find(c => c.id === selectedCause)?.title}</strong> has been received. You will get a confirmation on {donorEmail || 'your email'}.</p>
              <p style={{ color: 'var(--text-light)', fontSize: '0.9rem', marginTop: 12 }}>
                Jai Ganesh <img src={logo} alt="" style={{ height: '18px', verticalAlign: 'middle', display: 'inline' }} /> — May Lord Ganesha bless you with happiness and prosperity.
              </p>
              <button className="btn-primary" style={{ marginTop: 24 }} onClick={() => setSubmitted(false)}>Make Another Donation</button>
            </div>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="donate-page">
      <div className="page-hero">
        <div className="container">
          <div className="badge">Support the Cause</div>
          <h1>Make a Donation</h1>
          <p>Your generosity fuels our celebrations, empowers social activities and supports families in need across Valsad.</p>
        </div>
      </div>

      <section>
        <div className="container donate-layout">
          {/* Donation Form */}
          <div className="donate-form-col">
            <form className="donate-form card" onSubmit={handleSubmit}>
              <h2>Choose Your Contribution</h2>

              {/* Cause */}
              <div className="form-group">
                <label className="form-label">Select a Cause</label>
                <div className="causes-grid">
                  {causes.map((c) => (
                    <div
                      key={c.id}
                      className={`cause-item${selectedCause === c.id ? ' selected' : ''}`}
                      onClick={() => setSelectedCause(c.id)}
                    >
                      <span className="cause-emoji">
                        {c.id === 'ganesh'
                          ? <img src={logo} alt="Aarambh" style={{ height: '36px', objectFit: 'contain' }} />
                          : c.icon}
                      </span>
                      <span>{c.title}</span>
                    </div>
                  ))}
                </div>
                <p className="cause-desc">{causes.find(c => c.id === selectedCause)?.desc}</p>
              </div>

              {/* Amount */}
              <div className="form-group">
                <label className="form-label">Select Amount</label>
                <div className="amount-grid">
                  {presets.map((amt) => (
                    <button
                      key={amt}
                      type="button"
                      className={`amount-btn${selectedAmount === amt && !customAmount ? ' selected' : ''}`}
                      onClick={() => { setSelectedAmount(amt); setCustomAmount(''); }}
                    >
                      {amt}
                    </button>
                  ))}
                </div>
                <div className="custom-amount">
                  <span className="rupee-prefix">₹</span>
                  <input
                    type="number"
                    placeholder="Enter custom amount"
                    value={customAmount}
                    onChange={(e) => { setCustomAmount(e.target.value); setSelectedAmount(''); }}
                    min="10"
                  />
                </div>
              </div>

              {/* Donor Info */}
              <div className="form-group">
                <label className="form-label">Your Information</label>
                <label className="anonymous-toggle">
                  <input type="checkbox" checked={anonymous} onChange={(e) => setAnonymous(e.target.checked)} />
                  <span>Donate anonymously</span>
                </label>
                {!anonymous && (
                  <div className="donor-fields">
                    <input
                      type="text"
                      className="form-input"
                      placeholder="Full Name *"
                      value={donorName}
                      onChange={(e) => setDonorName(e.target.value)}
                      required={!anonymous}
                    />
                    <input
                      type="email"
                      className="form-input"
                      placeholder="Email Address *"
                      value={donorEmail}
                      onChange={(e) => setDonorEmail(e.target.value)}
                      required={!anonymous}
                    />
                    <input
                      type="tel"
                      className="form-input"
                      placeholder="Phone Number"
                      value={donorPhone}
                      onChange={(e) => setDonorPhone(e.target.value)}
                    />
                  </div>
                )}
              </div>

              <button type="submit" className="btn-primary donate-submit">
                🙏 Donate {customAmount ? `₹${customAmount}` : selectedAmount}
              </button>
              <p className="donate-secure">🔒 Secure donation • 80G Tax Receipt available</p>
            </form>
          </div>

          {/* Sidebar */}
          <div className="donate-sidebar">
            <div className="impact-card card">
              <h3>Your Impact</h3>
              <div className="impact-items">
                <div className="impact-item">
                  <span className="impact-amount">₹101</span>
                  <span className="impact-desc">feeds a family for one day</span>
                </div>
                <div className="impact-item">
                  <span className="impact-amount">₹501</span>
                  <span className="impact-desc">sponsors a medical check-up for 5 people</span>
                </div>
                <div className="impact-item">
                  <span className="impact-amount">₹1,001</span>
                  <span className="impact-desc">plants 20 saplings & supports 2 families</span>
                </div>
                <div className="impact-item">
                  <span className="impact-amount">₹5,001</span>
                  <span className="impact-desc">fully sponsors a social activity event</span>
                </div>
              </div>
            </div>

            <div className="donors-card card">
              <h3>Recent Donors</h3>
              <div className="donors-list">
                {recentDonors.map((d, i) => (
                  <div key={i} className="donor-row">
                    <div className="donor-avatar">
                      {d.name === 'Anon' ? '🎭' : d.name[0]}
                    </div>
                    <div className="donor-info">
                      <strong>{d.name}</strong>
                      <span>{d.cause}</span>
                    </div>
                    <div className="donor-right">
                      <span className="donor-amount">{d.amount}</span>
                      <span className="donor-time">{d.time}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="trust-card card">
              <h3>🛡️ Why Trust Us?</h3>
              <ul>
                <li>✅ Registered charitable trust</li>
                <li>✅ 80G tax exemption certificate</li>
                <li>✅ Monthly expenditure reports published</li>
                <li>✅ All donations acknowledged</li>
                <li>✅ Governed by a volunteer committee</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
